exports = module.exports = require("./../../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cui-ruble{display:inline-block}.cui-ruble:before{font-family:Lato,sans-serif;font-weight:400;text-transform:none;content:\"\\20BD\"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?-autoprefixer&importLoaders=1!./~/postcss-loader!./~/stylus-loader!./~/@cian/ui/app/components/ruble/styles.styl
// module id = 857
// module chunks = 0